import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const navLinks = [
    { name: 'INÍCIO', path: '/' },
    { name: 'QUEM SOU EU', path: '/minhahistoria' },
    { name: 'VIAGENS', path: '/minhasviagens' },
    { name: 'CONTATO', path: '/contato' },
  ];

  const navbarBg = !isHomePage || isScrolled ? 'bg-white shadow-lg' : 'bg-transparent';
  const textColor = !isHomePage || isScrolled ? 'text-[#3D2817]' : 'text-white';
  const hoverColor = !isHomePage || isScrolled ? 'hover:text-[#6B5744]' : 'hover:text-white/80';

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navbarBg} py-4`}
      >
        <div className="max-w-[1800px] mx-auto px-8">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link
              to="/"
              className={`flex flex-col leading-tight transition-colors cursor-pointer ${textColor}`}
            >
              <span className="text-2xl font-bold tracking-wider" style={{ fontFamily: "'Anton', sans-serif" }}>
                ELIANE DA SILVA MORAES
              </span>
              <span className="text-xs tracking-[0.3em] font-bold text-[#B8860B]" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                ADVOGADA
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-12">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-base font-bold tracking-wider transition-colors cursor-pointer ${textColor} ${hoverColor}`}
                  style={{ fontFamily: "'Anton', sans-serif" }}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button
              type="button"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden cursor-pointer z-[60] relative"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i
                  className={`${
                    isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
                  } text-3xl transition-all duration-200 ${
                    isMobileMenuOpen ? 'text-[#3D2817]' : textColor
                  }`}
                />
              </div>
            </button>
          </div>
        </div>
      </nav>

      {/* Backdrop overlay com blur */}
      <div
        className={`fixed inset-0 z-[55] transition-all duration-300 lg:hidden ${
          isMobileMenuOpen
            ? 'opacity-100 pointer-events-auto'
            : 'opacity-0 pointer-events-none'
        }`}
        style={{ backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)', backgroundColor: 'rgba(255,255,255,0.55)' }}
        onClick={() => setIsMobileMenuOpen(false)}
      />

      {/* Mobile Menu Panel */}
      <div
        className={`fixed top-0 left-0 right-0 z-[58] lg:hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 -translate-y-4 pointer-events-none'
        }`}
      >
        <div className="bg-white/95 shadow-2xl mx-4 mt-20 rounded-2xl overflow-hidden">
          <div className="px-6 py-6 space-y-1">
            {navLinks.map((link, index) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-4 px-4 py-4 rounded-xl hover:bg-[#F5EFE8] transition-colors cursor-pointer group"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <span
                  className="text-lg font-bold tracking-wider text-[#3D2817] group-hover:text-[#B8860B] transition-colors whitespace-nowrap"
                  style={{ fontFamily: "'Anton', sans-serif" }}
                >
                  {link.name}
                </span>
                <div className="w-4 h-4 flex items-center justify-center ml-auto">
                  <i className="ri-arrow-right-s-line text-[#B8860B] text-xl" />
                </div>
              </Link>
            ))}
          </div>

          <div className="px-6 pb-6">
            <div className="border-t border-[#E8DDD4] pt-5">
              <p className="text-xs text-[#9E8B7D] tracking-widest text-center" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                ELIANE MORAES — ADVOGADA
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
